<template>
  <div class="seller-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Cobranças &raquo; Informações d{{ letter }} {{ termSingular }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <b-row class="mb-3" v-if="sellerForm.id != null">
          <b-col>
            <div class="alert text-center" :class="getStatus(sellerForm).class" role="alert">
              <p class="mb-0">{{getStatus(sellerForm).name}}</p>
            </div>
          </b-col>
        </b-row>
        <validation-observer ref="sellerForm" v-slot="{ invalid }">
          <b-form-row class="mb-2">
            <b-col cols="12" md="8">
              <b-row>
                <b-col cols="12">
                  <div class="box-cj">
                    <div class="header">
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="title">Dados de cadastro</p>
                        <div class="box-status">
                          <i class="fa fa-circle ml-2" :title="isBoxIncomplete('general') ? 'Incompleto' : 'Completo'" :class="'status-indicator ' + (isBoxIncomplete('general') ? 'incomplete' : 'complete')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Tipo</label>
                          <validation-provider name="tipo" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="sellerForm.type" :options="sellerTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo" :disabled="sellerForm.id != null" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Categoria do negócio</label>
                          <validation-provider name="categoria do negócio" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="sellerForm.category" :options="sellerCategoryOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Selecione uma categoria" :disabled="sellerForm.zoop_seller_id != null" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <template v-if="sellerForm.type.value == 'pj'">
                        <b-row class="mb-2">
                          <b-col>
                            <label class="cj-label">CNPJ</label>
                            <validation-provider name="CNPJ" :rules="{ required: true, cnpj: true }" v-slot="{ errors }">
                              <b-form-input type="tel" v-model="sellerForm.company_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['##.###.###/####-##']" :disabled="sellerForm.zoop_seller_id != null"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Razão social</label>
                            <validation-provider name="razão social" :rules="{ required: true }" v-slot="{ errors }">
                              <b-form-input type="text" v-model="sellerForm.company_name" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="sellerForm.zoop_seller_id != null"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-2">
                          <b-col>
                            <label class="cj-label">Nome fantasia</label>
                            <b-form-input type="text" v-model="sellerForm.company_fantasy_name" autocomplete="off"></b-form-input>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Data de abertura</label>
                            <validation-provider name="data de abertura" :rules="{ required: true }" v-slot="{ errors }">
                              <date-picker name="company_opening_date" v-model="sellerForm.company_opening_date" :class="{ 'error': errors.length > 0 }" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off" :disabled="sellerForm.zoop_seller_id != null"></date-picker>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-2">
                          <b-col>
                            <label class="cj-label">Faturamento</label>
                            <validation-provider name="faturamento" :rules="{ required: true }" v-slot="{ errors }">
                              <money v-model="sellerForm.income" class="form-control mb-2" :disabled="sellerForm.zoop_seller_id != null" :class="{ 'error': errors.length > 0 }"></money>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col></b-col>
                        </b-row>
                      </template>
                      <b-row class="mb-2">
                        <b-col cols="12" v-if="sellerForm.type.value == 'pj'">
                          <hr>
                          <p>Dados do proprietário</p>
                        </b-col>
                        <b-col cols="12">
                          <label class="cj-label">Nome completo</label>
                          <validation-provider name="nome completo" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="sellerForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="sellerForm.zoop_seller_id != null"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">CPF</label>
                          <validation-provider name="CPF" :rules="{ required: true, cpf: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']" :disabled="sellerForm.zoop_seller_id != null"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Data de nascimento</label>
                          <validation-provider name="data de nascimento" :rules="{ required: true }" v-slot="{ errors }">
                            <date-picker name="birthday" v-model="sellerForm.birthday" :class="{ 'error': errors.length > 0 }" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off" :disabled="sellerForm.zoop_seller_id != null"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Telefone</label>
                          <validation-provider name="telefone" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.telephone" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">E-mail</label>
                          <validation-provider name="e-mail" :rules="{ required: true, email: true }" v-slot="{ errors }">
                            <b-form-input type="email" v-model="sellerForm.email" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="sellerForm.zoop_seller_id != null"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2" v-if="sellerForm.type.value == 'pf'">
                        <b-col>
                          <label class="cj-label">Renda</label>
                          <validation-provider name="renda" :rules="{ required: true }" v-slot="{ errors }">
                            <money v-model="sellerForm.income" class="form-control mb-2" :disabled="sellerForm.zoop_seller_id != null" :class="{ 'error': errors.length > 0 }"></money>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </div>
                    <div class="footer" v-if="(sellerForm.id == null && canAdd) || (sellerForm.id != null && canEdit)">
                      <b-button variant="primary" class="mr-3" @click="saveSeller" :disabled="!canPerformAction">Salvar</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="box-cj">
                    <div class="header">
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="title">Endereço</p>
                        <div class="box-status">
                          <i class="fa fa-circle ml-2" :title="isBoxIncomplete('address') ? 'Incompleto' : 'Completo'" :class="'status-indicator ' + (isBoxIncomplete('address') ? 'incomplete' : 'complete')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">CEP</label>
                          <validation-provider name="cep" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.address.zip_code" v-mask="'#####-###'" :class="{ 'error': errors.length > 0 }" v-on:blur="findCep(sellerForm.address.zip_code)" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="8">
                          <label class="cj-label">Endereço</label>
                          <validation-provider name="endereço" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="sellerForm.address.address" ref="address" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Número</label>
                          <validation-provider name="número" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.address.number" ref="number" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Complemento</label>
                          <b-form-input type="text" v-model="sellerForm.address.complement" autocomplete="off"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Bairro</label>
                          <validation-provider name="bairro" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="sellerForm.address.neighborhood" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Cidade</label>
                          <validation-provider name="cidade" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="sellerForm.address.city" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Estado</label>
                          <validation-provider name="estado" :rules="{ required: true, length: 2 }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="sellerForm.address.state" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="footer" v-if="(sellerForm.id == null && canAdd) || (sellerForm.id != null && canEdit)">
                      <b-button variant="primary" class="mr-3" @click="saveSeller">Salvar</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="box-cj">
                    <div class="header">
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="title">Conta para recebimento</p>
                        <div class="box-status">
                          <i class="fa fa-circle ml-2" :title="isBoxIncomplete('bank_account') ? 'Incompleto' : 'Completo'" :class="'status-indicator ' + (isBoxIncomplete('bank_account') ? 'incomplete' : 'complete')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Titular</label>
                          <b-form-input type="text" :value="sellerForm.company_name != null ? sellerForm.company_name : sellerForm.name" disabled></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Banco</label>
                          <validation-provider name="banco" :rules="{ required: hasFilledBankInput() }" v-slot="{ errors }">
                            <multiselect v-model="sellerForm.bankAccount.bank" :options="bankOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione um banco" :class="{ 'error': errors.length > 0 }">
                              <template slot="clear">
                                <div class="multiselect__clear" v-if="sellerForm.bankAccount.bank != null" @mousedown.prevent.stop="sellerForm.bankAccount.bank = null"></div>
                              </template>
                            </multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Tipo de conta</label>
                          <multiselect v-model="sellerForm.bankAccount.type" :options="bankTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de conta"></multiselect>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Agência (sem DV)</label>
                          <validation-provider name="agência" :rules="{ required: hasFilledBankInput() }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.bankAccount.agency" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="'###########'"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Conta (com DV)</label>
                          <validation-provider name="conta" :rules="{ required: hasFilledBankInput() }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="sellerForm.bankAccount.account" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="'###############'"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="footer" v-if="(sellerForm.id == null && canAdd) || (sellerForm.id != null && canEdit)">
                      <b-button variant="primary" class="mr-3" @click="saveSeller" :disabled="!canPerformAction">Salvar</b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="4">
              <b-row>
                <b-col cols="12">
                  <div class="box-cj">
                    <div class="header">
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="title">Documentos</p>
                        <div class="box-status">
                          <i class="fa fa-circle ml-2" :title="isBoxIncomplete('documents') ? 'Incompleto' : 'Completo'" :class="'status-indicator ' + (isBoxIncomplete('documents') ? 'incomplete' : 'complete')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <b-row class="mb-2">
                        <b-col cols="12" v-if="sellerForm.type.value == 'pj'">
                          <p>Cartão CNPJ/Contrato social</p>
                        </b-col>
                        <b-col cols="12" class="mb-2" v-if="sellerForm.type.value == 'pj'">
                          <label class="cj-label">Cópia do cartão do CNPJ ou cópia do contrato social da empresa</label>
                          <b-form-file v-if="!sellerForm.documents.cnpj.uploaded" v-model="sellerForm.documents.cnpj.selected_file" @input="attachmentChanged('cnpj')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>
                          <span v-else class="d-block document-sent"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                        </b-col>
                        <b-col cols="12">
                          <hr v-if="sellerForm.type.value == 'pj'">
                          <p>Comprovante de atividade</p>
                        </b-col>
                        <b-col cols="12" class="mb-2">
                          <label class="cj-label">Comprovante da atividade exercida (cartão de visita, print do site, nota fiscal de compra de produtos ou prestação de serviços, etc)</label>
                          <b-form-file v-if="!sellerForm.documents.atividade.uploaded" v-model="sellerForm.documents.atividade.selected_file" @input="attachmentChanged('atividade')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>
                          <span v-else class="d-block document-sent"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                        </b-col>
                        <b-col cols="12">
                          <hr>
                          <p>Documento de identidade</p>
                        </b-col>
                        <b-col cols="12" class="mb-2">
                          <label class="cj-label">Documento de identidade com foto (RG e CPF ou CNH){{sellerForm.type.value == 'pj' ? ' do proprietário/sócios' : ''}}</label>
                          <b-form-file v-if="!sellerForm.documents.identificacao.uploaded" v-model="sellerForm.documents.identificacao.selected_file" @input="attachmentChanged('identificacao')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>
                          <span v-else class="d-block document-sent"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                        </b-col>
                        <b-col cols="12">
                          <hr>
                          <p>Comprovante de residência</p>
                        </b-col>
                        <b-col cols="12" class="mb-2">
                          <label class="cj-label">Comprovante de residência em {{sellerForm.type.value == 'pj' ? 'nome do proprietário/sócios' : 'seu nome (ou de familiares)'}}</label>
                          <b-form-file v-if="!sellerForm.documents.residencia.uploaded" v-model="sellerForm.documents.residencia.selected_file" @input="attachmentChanged('residencia')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>
                          <span v-else class="d-block document-sent"><i class="fa fa-check text-success mr-1"></i>Enviado</span>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="footer" v-if="(sellerForm.id == null && canAdd) || (sellerForm.id != null && canEdit)">
                      <b-button variant="primary" class="mr-3" @click="saveSeller" :disabled="!canPerformAction">Salvar</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" v-if="sellerForm.id != null && canRemove">
                  <div class="box-cj">
                    <div class="header">
                      <p class="title">Remover {{ termSingular }}</p>
                    </div>
                    <div class="content">
                      <validation-observer ref="removeForm" v-slot="{ invalid }">
                        <b-row class="mb-2">
                          <b-col>
                            <label class="cj-label">Informe {{ sellerForm.type.value == 'pj' ? 'a razão social' : 'o nome completo' }} d{{ letter }} {{ termSingular }}</label>
                            <validation-provider :name="(sellerForm.type.value == 'pj' ? 'razão social' : 'nome completo') + ' d'+letter+' '+termSingular"  v-slot="{ errors }">
                              <b-form-input type="text" v-model="deleteForm.verification" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                      </validation-observer>
                    </div>
                    <div class="footer">
                      <b-button variant="danger" class="mr-3" @click="deleteSeller" block :disabled="((sellerForm.type.value == 'pj' ? sellerForm.company_name : sellerForm.name) != deleteForm.verification)">Remover {{ termSingular }}</b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-form-row>
        </validation-observer>
      </div>
    </b-container>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'conta de cobrança',
        termPlural: 'contas de cobrança',
        url: 'contas-de-cobranca',
        letter: 'a',
        newTerm: 'cadastrar-conta-de-cobranca',
        module: 'sellers',
        user: null,

        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        sellerTypeOptions: [
          {value: 'pf', name: 'Pessoa física'},
          {value: 'pj', name: 'Pessoa jurídica'}
        ],
        bankOptions: [],
        bankTypeOptions: [
          {value: '0', name: 'Conta corrente'},
          {value: '1', name: 'Poupança'}
        ],
        sellerCategoryOptions: [],
        sellerForm: {
          id: null,
          status: 'INCOMPLETE',
          zoop_seller_id: null,
          category: null,
          type: {value: 'pf', name: 'Pessoa física'},
          company_document: null,
          company_name: null,
          company_fantasy_name: null,
          company_opening_date: null,
          income: 0,
          name: null,
          document: null,
          email: null,
          birthday: null,
          telephone: null,
          documents: {
            cnpj: {file: null, file_name: null, selected_file: null, uploaded: false},
            atividade: {file: null, file_name: null, selected_file: null, uploaded: false},
            identificacao: {file: null, file_name: null, selected_file: null, uploaded: false},
            residencia: {file: null, file_name: null, selected_file: null, uploaded: false},
          },
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          bankAccount: {
            bank: null,
            type: {value: '0', name: 'Conta corrente'},
            agency: null,
            account: null,
          }
        },

        permissions: this.helpers.getModules(),

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },


        deleteForm: {
          verification: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.user = JSON.parse(localStorage.getItem('user'));

      this.canAdd = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_edit');
      // this.canRemove = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canRemove = false;
      this.canManage = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_manage');

      await this.api.getSellerConfigData().then(res => {
        if(this.leavingPage) {
          return;
        }
        this.bankOptions = [];
        this.sellerCategoryOptions = [];
        res.data.banks.forEach(bank => {
          this.bankOptions.push({ value: bank.id, name: bank.name });
        });
        res.data.categories.forEach(category => {
          this.sellerCategoryOptions.push({ value: category.id, name: category.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Seller Config Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as categorias! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Seller Config Data', err.response);
      });


      if(this.$route.params.id != this.newTerm) {
        await this.api.getSeller(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let sellerData = res.data;

          let address = (sellerData.address == null) ? {
            id: null,
            zip_code: '',
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          } : sellerData.address;
          let bankAccount = (sellerData.latest_bank_account == null) ? {
            bank: null,
            type: {value: '0', name: 'Conta corrente'},
            agency: null,
            account: null,
          } : sellerData.latest_bank_account;

          if(sellerData.latest_bank_account != null) {
            bankAccount.bank = this.bankOptions.find(g => g.value == sellerData.latest_bank_account.bank_id);
            bankAccount.type = this.bankTypeOptions.find(g => g.value == sellerData.latest_bank_account.is_savings ? 1 : 0);
          }

          this.sellerForm = {
            id: sellerData.id,
            status: sellerData.status,
            zoop_seller_id: sellerData.zoop_seller_id,
            type: this.sellerTypeOptions.find(g => g.value == (sellerData.company_document == null ? 'pf' : 'pj')),
            category: this.sellerCategoryOptions.find(g => g.value == sellerData.zoop_seller_category),
            company_name: sellerData.company_name,
            company_fantasy_name: sellerData.company_fantasy_name,
            company_document: sellerData.company_document,
            company_opening_date: (this.moment(sellerData.company_opening_date).isValid())?this.moment(sellerData.company_opening_date).format('DD/MM/YYYY'):'',
            income: sellerData.income,
            name: sellerData.name,
            document: sellerData.document,
            email: sellerData.email,
            telephone: sellerData.telephone,
            birthday: (this.moment(sellerData.birthday).isValid())?this.moment(sellerData.birthday).format('DD/MM/YYYY'):'',
            documents: {
              cnpj: {file: null, file_name: null, selected_file: null, uploaded: sellerData.zoop_seller_company_document_id != null},
              atividade: {file: null, file_name: null, selected_file: null, uploaded: sellerData.zoop_seller_activity_document_id != null},
              identificacao: {file: null, file_name: null, selected_file: null, uploaded: sellerData.zoop_seller_id_document_id != null},
              residencia: {file: null, file_name: null, selected_file: null, uploaded: sellerData.zoop_seller_residence_document_id != null},
            },
            address: address,
            bankAccount: bankAccount
          };


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Seller', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/cobrancas/' + this.url});

          this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Seller', err.response);
        });
      } else {
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      async saveSeller() {
        if(!this.canPerformAction || (this.sellerForm.id == null && !this.canAdd) || (this.sellerForm.id != null && !this.canEdit)) {
          return false;
        }

        const isValid = await this.$refs.sellerForm.validate();
        if(!isValid) {
          return false;
        }

        if(this.isBoxIncomplete('bank_account') || this.isBoxIncomplete('documents')) {
          this.$swal({
            title: 'Cadastro incompleto',
            text: 'O cadastro só será processado depois que todos os dados forem preenchidos. Deseja salvar e finalizar o preenchimento depois?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if (res.value) {
              this.saveSellerRequest();
            }
          });
        }
        else {
          await this.saveSellerRequest();
        }
      },

      async saveSellerRequest() {
        this.canPerformAction = false;

        this.eventBus.$emit('IS_LOADING', true);

        let isCompany = this.sellerForm.type.value == 'pj';
        let sellerData =  {
          id: this.sellerForm.id,
          zoop_seller_category: this.sellerForm.category.value,
          company_name: isCompany ? this.sellerForm.company_name : null,
          company_fantasy_name: isCompany ? this.sellerForm.company_fantasy_name : null,
          company_document: isCompany ? this.sellerForm.company_document : null,
          company_opening_date: isCompany ? this.sellerForm.company_opening_date : null,
          name: this.sellerForm.name,
          document: this.sellerForm.document,
          email: this.sellerForm.email,
          income: this.sellerForm.income,
          birthday: this.sellerForm.birthday,
          telephone: this.sellerForm.telephone,
          address: {
            id: this.sellerForm.address.id,
            zip_code: this.sellerForm.address.zip_code,
            address: this.sellerForm.address.address,
            number: this.sellerForm.address.number,
            complement: this.sellerForm.address.complement,
            neighborhood: this.sellerForm.address.neighborhood,
            city: this.sellerForm.address.city,
            state: this.sellerForm.address.state,
            country: 'Brazil'
          },
          bank_account: {
            bank_id: this.sellerForm.bankAccount.bank != null ? this.sellerForm.bankAccount.bank.value : null,
            is_savings: this.sellerForm.bankAccount.type.value,
            agency: this.sellerForm.bankAccount.agency,
            account: this.sellerForm.bankAccount.account
          },
          documents: {}
        };
        if(this.sellerForm.documents.cnpj.file != null) {
          sellerData.documents.cnpj = this.sellerForm.documents.cnpj;
        }
        if(this.sellerForm.documents.atividade.file != null) {
          sellerData.documents.atividade = this.sellerForm.documents.atividade;
        }
        if(this.sellerForm.documents.identificacao.file != null) {
          sellerData.documents.identificacao = this.sellerForm.documents.identificacao;
        }
        if(this.sellerForm.documents.residencia.file != null) {
          sellerData.documents.residencia = this.sellerForm.documents.residencia;
        }

        if (this.sellerForm.id == null) {
          this.api.storeSeller(sellerData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi cadastrad' + this.letter + ' com sucesso!', 'success').then(() => {
                this.$router.push({path: '/cobrancas/' + this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Seller', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' });
              });
            }
            else {
              let message = 'Não conseguimos cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: {
                  if(typeof response.data.message != 'undefined' && response.data.message != '') {
                    if(response.data.message.indexOf('duplicate_taxpayer_id:') >= 0) {
                      message = 'Já existe um cadastro com este ' + (isCompany ? 'CNPJ' : 'CPF') + '.';
                    }
                    else if(response.data.message.indexOf('Your "taxpayer_id" value is incorrect') >= 0) {
                      message = 'CPF inválido.';
                    }
                    else if(response.data.message.indexOf('Your "ein" value is incorrect') >= 0) {
                      message = 'CNPJ inválido.';
                    }
                    else {
                      message = response.data.message;
                    }
                  }
                  break;
                }
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Seller', err);
          });
        } else {
          this.api.updateSeller(this.sellerForm.id, sellerData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi atualizado com sucesso!', 'success').then(() => {
                this.$router.push({path: '/cobrancas/' + this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Seller', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' });
              });
            }
            else {
              let message = 'Não conseguimos atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: {
                  if(typeof response.data.message != 'undefined' && response.data.message != '') {
                    message = response.data.message;
                  }
                  break;
                }
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Seller', err);
          });
        }
      },

      hasFilledBankInput() {
        let fields = this.sellerForm.bankAccount;
        return fields.bank != null || !this.isNullOrEmpty(fields.agency) || !this.isNullOrEmpty(fields.account);
      },

      attachmentChanged(index) {
        let attachment = this.sellerForm.documents[index];
        attachment.file = null;
        attachment.file_name = '';
        if (attachment.selected_file) {
          attachment.file_name = attachment.selected_file.name;
          const reader = new FileReader();
          reader.onload = (event) => {
            attachment.file = event.target.result;
          };
          reader.readAsDataURL(attachment.selected_file);
        }
      },

      getStatus(seller) {
        if(seller.status == 'INCOMPLETE') {
          return {name:'O cadastro está incompleto.', class: 'alert-danger'};
        }
        else if(seller.status == 'pending') {
          return {name:'A conta de cobrança está em análise.', class: 'alert-warning'};
        }
        else if(seller.status == 'enabled' || seller.status == 'active') {
          return {name:'A conta de cobrança está habilitada.', class: 'alert-success'};
        }
        else if(seller.status == 'deleted') {
          return {name:'A conta de cobrança foi excluída.', class: 'alert-danger'};
        }
        else {
          return {name:'A conta de cobrança está desabilitada.', class: 'alert-danger'};
        }
      },

      isBoxIncomplete(box) {
        let form = this.sellerForm;
        if(box == 'general') {
          return form.category == null || (form.type.value == 'pj' && (this.isNullOrEmpty(form.company_document) || this.isNullOrEmpty(form.company_name) || this.isNullOrEmpty(form.company_opening_date))) || this.isNullOrEmpty(form.name) || this.isNullOrEmpty(form.document) || this.isNullOrEmpty(form.birthday) || this.isNullOrEmpty(form.telephone) || this.isNullOrEmpty(form.email) || this.isNullOrEmpty(form.income);
        }
        if(box == 'address') {
          let address = form.address;
          return this.isNullOrEmpty(address.zip_code) || this.isNullOrEmpty(address.address) || this.isNullOrEmpty(address.number) || this.isNullOrEmpty(address.neighborhood) || this.isNullOrEmpty(address.city) || this.isNullOrEmpty(address.state);
        }
        if(box == 'bank_account') {
          let bank = form.bankAccount;
          return bank.bank == null || this.isNullOrEmpty(bank.agency) || this.isNullOrEmpty(bank.account);
        }
        if(box == 'documents') {
          let documents = form.documents;
          return (form.type.value == 'pj' && documents.cnpj.file == null && !documents.cnpj.uploaded) || (documents.atividade.file == null && !documents.atividade.uploaded) || (documents.identificacao.file == null && !documents.identificacao.uploaded) || (documents.residencia.file == null && !documents.residencia.uploaded);
        }
      },

      async deleteSeller() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação é irreversível!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover ' + this.letter + ' ' + this.termSingular + '!',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);

            let deleteData = {
              verification: this.deleteForm.verification
            };

            this.api.deleteSeller(this.sellerForm.id, deleteData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi removido com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/cobrancas/' + this.url});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Destroy Seller', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Destroy Seller', err.response);
            });
          }
        });
      },

      findCep(value) {
        if (value != null && value.length == 9) {
          axios.get('https://viacep.com.br/ws/' + value + '/json/').then(res => {
            if (typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.sellerForm.address.address = cepData.logradouro;
              this.sellerForm.address.neighborhood = cepData.bairro;
              this.sellerForm.address.city = cepData.localidade;
              this.sellerForm.address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {
              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      goBack() {
        this.$router.push({path: '/cobrancas/' + this.url});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .seller-form {
    padding: 20px 0;


    .box-status {
      font-size: 14px;

      .status-indicator {
        &.complete {
          color: $ufoGreen;
        }
        &.incomplete {
          color: $yellowSea;
        }
      }
    }

    .document-sent {
      font-size: 14px;
    }
  }
</style>
